import { TFunction } from 'react-i18next';
import { array, mixed, object } from 'yup';
import { hasNoDocuments } from '../../../newClaim/schema';

export interface ClaimFormState {
  // antd didn't export their file type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  receipts?: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  referralLetters?: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  otherDocuments?: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  prevClaimSettlements?: any[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const checkRequiredDocs = (parent: any) => {
  return parent?.requiredDocs && parent?.requiredDocs[1];
};

export const getClaimSchema = (t: TFunction) =>
  object({
    receipts: array(mixed()).test({
      name: 'receiptsTest',
      test: function (value, ctx) {
        if (hasNoDocuments(value) && hasNoDocuments(this.parent?.referralLetters)) {
          return ctx.createError({
            message: t('newClaim.supplementaryDocuments.uploadingReceiptInfo.receiptIsRequired'),
          });
        }
        return true;
      },
    }),
    referralLetters: array(mixed()).test({
      name: 'referralLettersTest',
      test: function (value, ctx) {
        if (checkRequiredDocs(this.parent) && hasNoDocuments(value) && hasNoDocuments(this.parent?.receipts)) {
          return ctx.createError({
            message: t('newClaim.supplementaryDocuments.uploadingReferralInfo.referralLetterIsRequired', {
              documentName: this.parent?.requiredDocs[1],
            }),
          });
        }
        return true;
      },
    }),
    otherDocuments: array(mixed()),
    prevClaimSettlements: array(mixed()).test({
      name: 'prevClaimSettlementsTest',
      test: function (value, ctx) {
        if (checkRequiredDocs(this.parent) && !value?.length) {
          return ctx.createError({
            message: t('newClaim.partialClaim.secondClaim.settlementAdviceTitleIsRequired', {
              documentName: this.parent?.requiredDocs[1],
            }),
          });
        }
        return true;
      },
    }),
  }).required();
